import type { ReactElement } from "react";
import { useMemo } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import {
    StyledCheckboxFilterContainer,
    StyledCheckboxFilterItem,
    StyledCheckboxFilterItemWrapper,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/styles";
import type { ICheckboxFilterOption } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/types";
import type { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";

import type FindContactDetailsFilter from "../../../models/ContactDetailsFilter/ContactDetailsFilter";

import { mapToTranslatedOptions } from "./utils";

const ContactDetailsFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindContactDetailsFilter>): ReactElement | null => {
    const optionItems = useMemo((): ICheckboxFilterOption<ContactDetail>[] => {
        return mapToTranslatedOptions(filter.options, "checkbox");
    }, [filter.options]);

    const handleTypeSelection = (selectedItem: ContactDetail, isSelected?: boolean) => {
        const currentValues = value ?? [];
        const updatedValues = isSelected
            ? currentValues.filter((v: ContactDetail) => v !== selectedItem)
            : [...currentValues, selectedItem];
        onFilterUpdate(updatedValues);
    };

    const renderType = (option: ICheckboxFilterOption<ContactDetail>) => {
        const isSelected: boolean = value?.includes(option.value) ?? false;

        return (
            <StyledCheckboxFilterItemWrapper key={option.label}>
                <StyledCheckboxFilterItem
                    selected={isSelected}
                    label={option.label}
                    onClick={() => handleTypeSelection(option.value, isSelected)}
                />
            </StyledCheckboxFilterItemWrapper>
        );
    };

    return (
        <StyledCheckboxFilterContainer>
            {optionItems.map((item: ICheckboxFilterOption<ContactDetail>) => renderType(item))}
        </StyledCheckboxFilterContainer>
    );
};

export default ContactDetailsFilter;
